import React, { useEffect } from "react";
import Header from "../components/Header";
import { motion } from "framer-motion";
import HowItWorks from "../components/HowItWorks";
import Footer from "../components/Footer";

const AboutUs = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <Header active="sobreNos" />

            {/* Seção Missão */}
            <div style={{
                marginTop: "80px",
                width: "100%",
                padding: "20px",
                backgroundColor: "#f9f2e4",
                color: "#0b243d"
            }}>
                <div style={{
                    width: "80%",
                    maxWidth: "1200px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    margin: "0 auto"
                }}>
                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <img
                            src="/assets/sobreNos.jpeg"
                            alt="Descrição"
                            style={{
                                width: "100%",
                                margin: "0 auto",
                                height: "auto",
                                borderRadius: "20px", // cantos arredondados suaves
                                objectFit: "cover",   // mantém proporção e evita distorção
                                boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                            }}
                        />
                    </motion.div>

                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>Missão</h1>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                            Oferecer soluções contábeis e fiscais de alta qualidade, com ética, sigilo e excelência, promovendo organização, crescimento e tranquilidade aos profissionais da saúde por meio de um suporte personalizado e 100% online.
                        </p>
                    </motion.div>
                </div>
            </div>

            {/* Seção principal */}
            <div style={{ backgroundColor: "", color: "black", padding: "40px 0" }}>
                <div
                    style={{
                        width: "80%",
                        maxWidth: "1200px",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "20px",
                        margin: "0 auto",
                        padding: "20px",
                    }}
                >
                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: 50, scale: 0.95 }}
                        whileInView={{ opacity: 1, x: 0, scale: 1 }}
                        transition={{
                            duration: 0.8,
                            delay: 0.2,
                            type: "spring",
                            stiffness: 100,
                            damping: 12,
                        }}
                        viewport={{ once: true }}
                    >
                        <h1 style={{ fontSize: "2rem", marginBottom: "10px" }}>
                            A Clarea é a contabilidade digital que cuida de quem cuida das pessoas.
                        </h1>
                        <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1rem" }}>
                            A Clarea Vital nasceu com um propósito claro: <b>ser referência nacional em contabilidade e serviços fiscais especializados para profissionais da saúde.</b>
                        </p>
                        <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1rem" }}>
                            Unimos tecnologia, precisão técnica e profundo conhecimento do setor para oferecer soluções contábeis seguras, claras e personalizadas. <b>Cada detalhe do nosso trabalho é pautado por ética, sigilo absoluto e dedicação total à sua tranquilidade.</b>
                        </p>
                        <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1rem" }}>
                            Mais do que números, entregamos <b>confiança</b>. Estamos ao lado de médicos, psicólogos, nutricionistas, preparadores físicos, gestores de clínicas e tantos outros que buscam <b>crescer com solidez</b>, sabendo que sua contabilidade está em mãos verdadeiramente especializadas.
                            {/* Valorizamos cada parceria, oferecendo suporte contábil personalizado, 100% online, pensado para a sua realidade. */}
                        </p>
                        <p style={{ fontSize: "1rem", lineHeight: "1.6", marginBottom: "1rem" }}>
                            <b>Na Clarea, excelência não é meta — é padrão.</b>
                        </p>
                    </motion.div>

                    <motion.div
                        style={{ flex: "1 1 300px" }}
                        initial={{ opacity: 0, x: -50, scale: 0.95 }}
                        whileInView={{ opacity: 1, x: 0, scale: 1 }}
                        transition={{ duration: 0.8, type: "spring", stiffness: 100, damping: 12 }}
                        viewport={{ once: true }}
                    >
                        <img src="/assets/sobreNos2.jpeg" alt="Descrição" style={{
                            width: "100%",
                            margin: "0 auto",
                            height: "auto",
                            borderRadius: "20px", // cantos arredondados suaves
                            objectFit: "cover",   // mantém proporção e evita distorção
                            boxShadow: "0 0px 14px #ffc845", // sombra leve para destacar
                        }} />
                    </motion.div>
                </div>
            </div>

            {/* Como funciona */}
            {/* <HowItWorks /> */}

            <Footer />
        </>
    );
};

export default AboutUs;
